import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef, useEffect } from 'react';
import '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import { mergeRefs } from '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Card from '../../Card/index.esm.js';
import Button from '../../Button/index.esm.js';
import Flex from '../../Flex/index.esm.js';
import '../../../hooks/use-safe-layout-effects.esm.js';
import '../../../hooks/use-callback-ref.esm.js';
import '../../../hooks/use-clickable.esm.js';
import '../../../hooks/use-clipboard.esm.js';
import '../../../hooks/use-combobox-dropdown-style.esm.js';
import '../../../hooks/use-combobox-style.esm.js';
import '../../../hooks/use-controllable.esm.js';
import '../../../hooks/use-local-storage.esm.js';
import '../../../hooks/use-media.esm.js';
import '../../../hooks/use-prefers-dark-mode.esm.js';
import '../../../hooks/use-dark-mode.esm.js';
import '../../../hooks/use-force-update.esm.js';
import '../../../hooks/use-descendant.esm.js';
import '../../../hooks/use-id.esm.js';
import '../../../hooks/use-previous.esm.js';
import '../../../hooks/use-disclosure.esm.js';
import { useDropdownStyle } from '../../../hooks/use-dropdown-style.esm.js';
import '../../../hooks/use-latest-ref.esm.js';
import '../../../hooks/use-event-listener.esm.js';
import '../../../hooks/use-event-listener-v2.esm.js';
import '../../../hooks/use-update-effect.esm.js';
import '../../../hooks/use-focus-on-hide.esm.js';
import '../../../hooks/use-pointer-event.esm.js';
import '../../../hooks/use-focus-on-pointerdown.esm.js';
import '../../../hooks/use-focus-on-show.esm.js';
import '../../../hooks/use-fork-ref.esm.js';
import '../../../hooks/use-hints.esm.js';
import '../../../hooks/use-input-style.esm.js';
import '../../../hooks/use-key-press.esm.js';
import '../../../hooks/use-lock-body-scroll.esm.js';
import '../../../hooks/use-platform.esm.js';
import '../../../hooks/use-shortcut.esm.js';
import Portal from '../../Portal/index.esm.js';
import { isAfter, isBefore, set } from 'date-fns';
import { enGB } from 'date-fns/locale';
import { DateRangePickerCalendar } from 'react-nice-dates';
import { useDateRangePickerContext } from '../context.esm.js';
import { isDisabledTime, isDisabledDate } from '../utils/index.esm.js';
import format from 'date-fns/format';
import PickerOverlay from './PickerOverlay.esm.js';
import PickerTime from './PickerTime.esm.js';

var PickerCalendar = function PickerCalendar() {
  var _useState = useState(false),
      showChild = _useState[0],
      setShowChild = _useState[1];

  var _useState2 = useState('DAY'),
      calendarState = _useState2[0],
      setCalendarState = _useState2[1];

  var _useState3 = useState(0),
      headerHeight = _useState3[0],
      setHeaderHeight = _useState3[1];

  var _useState4 = useState(0),
      contentHeight = _useState4[0],
      setContentHeight = _useState4[1];

  var _useDateRangePickerCo = useDateRangePickerContext(),
      open = _useDateRangePickerCo.open,
      closeMenu = _useDateRangePickerCo.closeMenu,
      getMenuProps = _useDateRangePickerCo.getMenuProps,
      size = _useDateRangePickerCo.size,
      popper = _useDateRangePickerCo.popper,
      startDate = _useDateRangePickerCo.startDate,
      setStartDate = _useDateRangePickerCo.setStartDate,
      endDate = _useDateRangePickerCo.endDate,
      setEndDate = _useDateRangePickerCo.setEndDate,
      focus = _useDateRangePickerCo.focus,
      setFocus = _useDateRangePickerCo.setFocus,
      monthYear = _useDateRangePickerCo.monthYear,
      setMonthYear = _useDateRangePickerCo.setMonthYear,
      includeTime = _useDateRangePickerCo.includeTime,
      autoChangeFocus = _useDateRangePickerCo.autoChangeFocus,
      disabledDate = _useDateRangePickerCo.disabledDate;

  var styles = useDropdownStyle({
    open: open
  });
  var parentRef = useRef(null);
  var width = size === 'sm' ? 350 : 440;
  var modifiers = {
    disabled: function disabled(checkDate) {
      return disabledDate ? isDisabledDate(checkDate, startDate, endDate, focus) || disabledDate(checkDate) : isDisabledDate(checkDate, startDate, endDate, focus);
    }
  };
  useEffect(function () {
    if (!open) {
      setCalendarState('DAY');
      return;
    }

    window.dispatchEvent(new Event('resize'));

    if (!headerHeight) {
      var _parentRef$current, _parentRef$current$qu;

      var height = (_parentRef$current = parentRef.current) == null ? void 0 : (_parentRef$current$qu = _parentRef$current.querySelector('.nice-dates-navigation')) == null ? void 0 : _parentRef$current$qu.clientHeight;

      if (height) {
        setHeaderHeight(height);
        setContentHeight("calc(100% - " + height + "px)");
      }
    }
  }, [open]);
  useEffect(function () {
    setShowChild(true);
  }, []);

  if (!showChild) {
    return null;
  }

  return React__default.createElement(Portal, null, React__default.createElement(Card, _extends({}, styles, {
    style: _extends({}, popper.style, {
      maxHeight: 'max-content'
    }),
    padding: "p-0",
    ref: mergeRefs(popper.ref, parentRef)
  }), React__default.createElement(Box, _extends({
    margin: "m-0"
  }, getMenuProps()), React__default.createElement(Flex, {
    margin: size === 'sm' ? 'my-2' : 'my-3'
  }, React__default.createElement(Box, {
    position: "relative",
    overflow: "overflow-hidden",
    margin: size === 'sm' ? 'mx-4' : 'mx-5',
    style: {
      width: width
    }
  }, React__default.createElement(PickerOverlay, _extends({}, {
    calendarState: calendarState,
    setCalendarState: setCalendarState,
    monthYear: monthYear,
    setMonthYear: setMonthYear,
    headerHeight: headerHeight,
    contentHeight: contentHeight,
    size: size
  })), React__default.createElement(DateRangePickerCalendar, {
    locale: enGB,
    modifiers: modifiers,
    focus: focus,
    startDate: startDate || undefined,
    endDate: endDate || undefined,
    onStartDateChange: function onStartDateChange(newDate) {
      if (newDate && endDate && isAfter(newDate, endDate)) {
        setStartDate(endDate);
      } else {
        setStartDate(newDate);
      }

      if (autoChangeFocus) {
        setFocus('endDate');
      }
    },
    onEndDateChange: function onEndDateChange(newDate) {
      if (newDate && startDate && isBefore(newDate, startDate)) {
        setEndDate(startDate);
      } else if (newDate && format(newDate, 'HH:mm') === '00:00') {
        setEndDate(set(newDate, {
          hours: 23,
          minutes: 59,
          seconds: 0,
          milliseconds: 0
        }));
      } else {
        setEndDate(newDate);
      }

      if (autoChangeFocus) {
        setFocus('startDate');
      }
    },
    month: monthYear,
    onMonthChange: function onMonthChange(newDate) {
      if (newDate) {
        setMonthYear(newDate);
      }
    }
  })), includeTime && React__default.createElement(Flex, {
    flexWrap: "flex-wrap",
    alignContent: "content-center",
    alignItems: "items-center",
    borderWidth: "border-l",
    borderColor: "border-gray-100",
    padding: size === 'sm' ? 'px-8' : 'px-10',
    gap: "gap-y-10",
    style: {
      width: width * 0.6
    }
  }, React__default.createElement(PickerTime, _extends({}, {
    size: size,
    width: width
  }, {
    label: "From",
    date: startDate,
    setDate: setStartDate,
    validate: function validate(newDate) {
      return disabledDate ? !isDisabledTime(newDate, startDate, endDate, 'startDate') && !disabledDate(newDate) : !isDisabledTime(newDate, startDate, endDate, 'startDate');
    }
  })), React__default.createElement(PickerTime, _extends({}, {
    size: size,
    width: width
  }, {
    label: "To",
    date: endDate,
    setDate: setEndDate,
    validate: function validate(newDate) {
      return disabledDate ? !isDisabledTime(newDate, startDate, endDate, 'endDate') && !disabledDate(newDate) : !isDisabledTime(newDate, startDate, endDate, 'endDate');
    }
  })))), React__default.createElement(Flex, {
    justifyContent: "justify-end",
    alignItems: "items-center",
    padding: size === 'sm' ? 'px-2' : 'px-4',
    borderWidth: "border-t",
    borderColor: "border-gray-100",
    style: {
      height: headerHeight || undefined
    }
  }, React__default.createElement(Button, {
    appearance: "primary",
    fontSize: size === 'sm' ? 'text-sm' : 'text-base',
    onClick: closeMenu
  }, "Save")))));
};

export default PickerCalendar;
//# sourceMappingURL=PickerCalendar.esm.js.map
